import React, { useEffect, useState, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import PropertyList from '../Componentes/PropertyList';
import FormularioBusqueda from '../Componentes/FormularioBusqueda';
import ImgInicio from '../Imagenes/banner.webp';
import '../Css/Home.css';
import axios from 'axios';

function Home() {
  const [searchParams] = useSearchParams();
  const estadoParam = searchParams.get('estado'); // Venta | Alquiler | Emprendimiento | null
  const catParam = searchParams.get('cat');       // "Departamento", "Casa", etc. (nombre del tipo)

  const [todasLasPropiedades, setTodasLasPropiedades] = useState([]);
  const [properties, setProperties] = useState([]);
  const [tiposPropiedad, setTiposPropiedad] = useState([]);

  const getTipoNombre = (tipoId) =>
    tiposPropiedad.find((t) => String(t._id) === String(tipoId))?.nombre || '';

  // Tu filtro actual desde el formulario (zona/estado/ambientes) se mantiene
  const aplicarFiltros = ({ zona, estado, ambientes }) => {
    const filtradas = todasLasPropiedades.filter((propiedad) => {
      const matchZona = zona
        ? propiedad.ubicacion?.toLowerCase().includes(zona.toLowerCase())
        : true;

      const matchEstado = estado ? propiedad.estado === estado : true;

      const matchAmbientes = ambientes
        ? propiedad.caracteristicas?.ambientes === Number(ambientes)
        : true;

      return matchZona && matchEstado && matchAmbientes;
    });

    setProperties(filtradas);
  };

  // Filtro inicial por URL (?estado & ?cat)
  const aplicarFiltrosDesdeURL = useMemo(() => {
    return () => {
      if (!todasLasPropiedades.length) return;
      // si no hay params, mostramos todo por defecto
      if (!estadoParam && !catParam) {
        setProperties(todasLasPropiedades);
        return;
      }

      const filtradas = todasLasPropiedades.filter((p) => {
        const matchEstado = estadoParam ? p.estado === estadoParam : true;
        const matchCat = catParam ? getTipoNombre(p.tipoPropiedad) === catParam : true;
        return matchEstado && matchCat;
      });

      setProperties(filtradas);
    };
  }, [todasLasPropiedades, tiposPropiedad, estadoParam, catParam]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [propsRes, tiposRes] = await Promise.all([
          axios.get('https://backend-admin-nine.vercel.app/api/propiedades'),
          axios.get('https://backend-admin-nine.vercel.app/api/types-propiedad'),
        ]);

        const propiedadesHabilitadas = propsRes.data.filter(
          (property) => property.habilitada !== false
        );

        setTodasLasPropiedades(propiedadesHabilitadas);
        setTiposPropiedad(tiposRes.data);
        // no seteamos properties acá: lo hará aplicarFiltrosDesdeURL
      } catch (error) {
        console.error('Error al obtener datos:', error);
      }
    };

    fetchAll();
  }, []);

  // Cuando llegan datos o cambian los params, aplicamos filtro de URL
  useEffect(() => {
    aplicarFiltrosDesdeURL();
  }, [aplicarFiltrosDesdeURL]);

  return (
    <div className="home-container">
      <div className="banner-container">
        <img src={ImgInicio} className="banner-img" alt="Imagen de inicio" />
        <div className="form-overlay">
          <FormularioBusqueda onFilterChange={aplicarFiltros} />
        </div>
      </div>
      <PropertyList properties={properties} />
    </div>
  );
}

export default Home;
